<template>
    <module-card :nextFunction="unlockResources">
        <p>
            Pre-Exposure Prophylaxis (or PrEP) is a prescription medicine that includes a combination of two HIV medicines (tenofovir and emtricitabine). It is approved for use among adolescents and adults and is sold under the name,
            Truvada®, which you might have heard of!
        </p>
        <v-img class="mx-auto" :max-width="200" :src="require('@/assets/hiv/prep.gif')" alt="PrEP"></v-img>
        <p>It is taken one time a day to reduce the risk of HIV infection. <strong>Studies have shown that PrEP has few side effects, and is very effective for preventing HIV infection if it is taken every day.</strong></p>
        <p>
            Even if you’re not 18 years old, you may be able to go on PrEP with the permission of your parent or caregiver. In some cases, if a young person is at risk for HIV infection, a medical provider might prescribe PrEP without a
            parent’s permission. If you are at risk for HIV infection and would like to take PrEP to prevent it, talk to your doctor.
        </p>
        <p>You can also go here to search for a PrEP provider near you: <external-link href="https://preplocator.org/" target="_blank">https://preplocator.org/</external-link></p>
        <p>
            For more information on PrEP: <external-link href="https://www.cdc.gov/hiv/basics/prep.html" target="_blank">https://www.cdc.gov/hiv/basics/prep.html</external-link> AND
            <external-link href="http://www.whatisprep.org/" target="_blank">http://www.whatisprep.org/</external-link>
        </p>
    </module-card>
</template>

<script>
    import { sync } from 'vuex-pathify';
    import { forEach } from 'lodash';

    export default {
        computed: {
            resources: sync('resources')
        },
        methods: {
            unlockResources() {
                // unlock alcohol and marijuana resources
                forEach(this.resources, (o) => {
                    if (o.category === 'HIV' && (o.topic === 'PrEP Locator' || o.topic === 'PrEP Basics' || o.topic === 'What is PrEP')) {
                        o.unlocked = true;
                    }
                });
            }
        }
    };
</script>
